export default "__VITE_ASSET__B0Rs1lJW__"